import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { FdeNoticeService } from '../../services/fde-notice.service';

/**
 * Shows the FDE raised through FdeNoticeService (message, credit reference # and BAN); placed once in
 * the order layout so every order page shows FDE the same way
 */
@Component({
  standalone: true,
  selector: 'app-fde-notice-dialog',
  imports: [ButtonModule, DialogModule],
  templateUrl: './fde-notice-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FdeNoticeDialogComponent {
  readonly #fdeNoticeService = inject(FdeNoticeService);
  readonly notice = this.#fdeNoticeService.notice;
  readonly visible = computed(() => !!this.notice());

  onVisibleChange(visible: boolean) {
    if (!visible) {
      this.close();
    }
  }

  close() {
    this.#fdeNoticeService.close();
  }
}
